import { useNavigate } from 'react-router-dom';
import { MaterialIcon } from '@/components/MaterialIcon';

export function NoAccessPage() {
  const navigate = useNavigate();
  return (
    <main className="flex min-h-screen items-center justify-center bg-[#F4F5F7] px-container-padding">
      <section className="w-full max-w-xl rounded-xl border border-outline-variant bg-surface-container-lowest p-container-padding">
        <div className="flex flex-col items-center text-center">
          <span className="mb-stack-md flex h-12 w-12 items-center justify-center rounded-full bg-error-container text-on-error-container">
            <MaterialIcon name="lock" size={24} />
          </span>
          <h1 className="font-headline-lg text-headline-lg text-on-surface">
            无权访问 Denox Identity Fabric Console
          </h1>
          <p className="mt-stack-md text-body-md text-on-surface-variant">
            控制台需要 <code className="font-code-md text-code-md">platform_admin</code> 角色，
            请联系管理员将你的飞书 union_id 加入{' '}
            <code className="font-code-md text-code-md">DENOX_IDENTITY__BOOTSTRAP_ADMIN_UNION_IDS</code>
            （首登时生效）。
          </p>
          <button
            type="button"
            onClick={() => navigate('/login', { replace: true })}
            className="mt-stack-md inline-flex items-center gap-unit rounded bg-primary px-stack-md py-stack-sm font-label-caps text-label-caps uppercase text-on-primary hover:bg-primary-container transition-colors duration-150"
          >
            <MaterialIcon name="arrow_back" size={14} />
            返回登录页
          </button>
        </div>
      </section>
    </main>
  );
}
